import React, { useState } from 'react';
import './FabHomepage.css';
import { useNavigate } from 'react-router-dom';
import RegisterCTA from './RegisterCTA.jsx';

function FabHomepage() {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    '/1.jpg',
    '/2.jpg',
    '/3.jpg',
    '/4.jpg',
    '/5.jpg',
    '/6.jpg',
    '/7.jpg',
    '/8.jpg',
  ];

  return (
    <div className="fab-homepage">
      <div className="fab-hero">
        <section className="fab-hero-content">
          <h1>FAB</h1>
          <h2>Competition  . Community . Camaraderie</h2>
          {/* <RegisterCTA /> */}
          <button onClick={() => navigate('/fastactionbasketball/leagueInfo')}>EXPLORE</button>
        </section>
      </div>

      <section className="fab-content-section">
        <div className="image-grid">
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`FAB ${index + 1}`}
              onClick={() => setSelectedImage(src)}
              className="grid-img"
            />
          ))}
        </div>
        <p>
          <strong>Fast Action Basketball</strong> is Southern California's Premier Adult League.
          Join us for an electrifying blend of camaraderie, fierce competition, and vibrant community.
        </p>
      </section>

      <div className="second-fab-hero">
        <section className="second-fab-hero-content">
          <p>
            In the winter of 1984, the Fast Action Basketball League was founded with the inception of
            the Southern California 3-on-3 Indoor Tournament. Hosted at the Los Angeles Forum, the
            tournament attracted over 200 teams hailing across Los Angeles and Orange County. From this
            humble beginning, Fast Action ignited, expanding to multiple locations and accommodating over
            350 teams every week, year-round, across three seasons annually.
          </p>
        </section>
      </div>

      <div className="third-fab-hero">
        <section className="third-fab-hero-content">
          <p>
            To date we have hosted over 35,000 adult basketball games and we’re still striving to provide
            quality competition autographed with excellence one game at a time.
          </p>
        </section>
      </div>

      <div className="fourth-fab-hero">
        <section className="fourth-fab-hero-content">
          <p>
            Over four decades later, we remain proudly family-owned and operated, maintaining our commitment
            to fostering a sense of community and camaraderie on and off the court.
          </p>
          <p>Come join us, and let us show you true competition,</p>
          <p>vital community connection, and inclusive service.</p>
          <p>We are FAB.</p>
        </section>
      </div>

      {selectedImage && (
        <div className="modal-backdrop" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Full View" />
          </div>
        </div>
      )}
    </div>
  );
}

export default FabHomepage;
